import { Radio } from 'antd';
import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 220px;
  padding: 4px 0;
  background: ${NeutralColors[0]};
`;

export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
